var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-row",
        { staticClass: "p-30 bg-white" },
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": "auto" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "关联类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.form.info_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "info_type", $$v)
                            },
                            expression: "form.info_type",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "不关联", value: -1 },
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.deviceNameObj, function (item, index) {
                            return _c("el-option", {
                              attrs: { label: index, value: item },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "名称：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "输入报名活动名称(分享标题)" },
                        model: {
                          value: _vm.form.info_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "info_name", $$v)
                          },
                          expression: "form.info_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "图片：" } },
                    [
                      _c("upload", {
                        attrs: { emitUrl: false, limit: 99 },
                        model: {
                          value: _vm.form.img_url,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "img_url", $$v)
                          },
                          expression: "form.img_url",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "微信号：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "" },
                        model: {
                          value: _vm.form.wechat,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "wechat", $$v)
                          },
                          expression: "form.wechat",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号码：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "" },
                        model: {
                          value: _vm.form.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "底部按钮文字：" } },
                    [
                      _c(
                        "el-input",
                        {
                          model: {
                            value: _vm.form.introduce.foot_text,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.introduce, "foot_text", $$v)
                            },
                            expression: "form.introduce.foot_text",
                          },
                        },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: { slot: "append", trigger: "hover" },
                              slot: "append",
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/gzh.jpg"),
                                  alt: "",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-button", {
                                attrs: {
                                  slot: "reference",
                                  icon: "el-icon-question",
                                },
                                slot: "reference",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "提交资料标题：" } },
                    [
                      _c(
                        "el-input",
                        {
                          model: {
                            value: _vm.form.introduce.modal_title,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.introduce, "modal_title", $$v)
                            },
                            expression: "form.introduce.modal_title",
                          },
                        },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: { slot: "append", trigger: "hover" },
                              slot: "append",
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/gzh.jpg"),
                                  alt: "",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-button", {
                                attrs: {
                                  slot: "reference",
                                  icon: "el-icon-question",
                                },
                                slot: "reference",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "提交资料按钮文字：" } },
                    [
                      _c(
                        "el-input",
                        {
                          model: {
                            value: _vm.form.introduce.modal_btntext,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.introduce, "modal_btntext", $$v)
                            },
                            expression: "form.introduce.modal_btntext",
                          },
                        },
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: { slot: "append", trigger: "hover" },
                              slot: "append",
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/gzh.jpg"),
                                  alt: "",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-button", {
                                attrs: {
                                  slot: "reference",
                                  icon: "el-icon-question",
                                },
                                slot: "reference",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }